if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.zoomScale = 1;
      this.zoomX = 0; this.zoomY = 0;
      this.pointers = new Map();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      // The inherited backdrop handler must not close the gallery when its controls are used.
      this.addEventListener('pointerup', (event) => {
        this.endPan(event);
        if (this.classList.contains('spx-product-zoom') &&
            event.target.closest('[data-media-id], button, .spx-zoom-nav')) event.stopImmediatePropagation();
      }, true);
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-spx-zoom-in]')) return this.setZoom(this.zoomScale + .5);
        if (event.target.closest('[data-spx-zoom-out]')) return this.setZoom(this.zoomScale - .5);
        if (event.target.closest('[data-spx-zoom-reset]')) return this.resetZoom();
        if (event.target.matches('.product-media-modal__content > img.active')) {
          if (this.dragged) { this.dragged = false; return; }
          this.setZoom(this.zoomScale > 1 ? 1 : 2.5, event.clientX, event.clientY);
          return;
        }
        const button = event.target.closest('[data-spx-zoom-step]');
        if (button) this.step(Number(button.dataset.spxZoomStep));
      });
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open') || !this.classList.contains('spx-product-zoom')) return;
        if (event.target.closest('input, textarea, select, video, iframe, model-viewer')) return;
        if (['+', '=', '-', '0'].includes(event.key)) {
          event.preventDefault();
          return event.key === '0' ? this.resetZoom() : this.setZoom(this.zoomScale + (event.key === '-' ? -.5 : .5));
        }
        if (this.zoomScale > 1 && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
          event.preventDefault();
          this.zoomX += event.key === 'ArrowLeft' ? 60 : event.key === 'ArrowRight' ? -60 : 0;
          this.zoomY += event.key === 'ArrowUp' ? 60 : event.key === 'ArrowDown' ? -60 : 0;
          this.paintZoom(); return;
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.step(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      this.addEventListener('wheel', event => {
        if (!this.hasAttribute('open') || !this.zoomImage || !event.target.closest('.product-media-modal__content')) return;
        event.preventDefault();
        this.setZoom(this.zoomScale + (event.deltaY < 0 ? .25 : -.25), event.clientX, event.clientY);
      }, { passive: false });
      this.addEventListener('pointerdown', event => this.startPan(event));
      this.addEventListener('pointermove', event => this.movePan(event));
      this.addEventListener('pointercancel', event => this.endPan(event));
      this.addEventListener('dragstart', event => { if (event.target === this.zoomImage) event.preventDefault(); });
    }

    endPan(event) {
      this.pointers.delete(event.pointerId);
      this.pinch = null;
      if (!this.pointers.size) this.classList.remove('is-panning');
    }
    get zoomImage() { return this.querySelector('.product-media-modal__content > img.active'); }
    resetZoom() {
      this.zoomScale = 1; this.zoomX = 0; this.zoomY = 0;
      this.pointers.clear(); this.pinch = null; this.dragged = false;
      this.classList.remove('is-panning');
      this.paintZoom();
    }
    setZoom(value, clientX, clientY) {
      if (this.closing) return;
      const image = this.zoomImage;
      if (!image) return;
      this.finishAnimations();
      const scale = Math.max(1, Math.min(4, value));
      const rect = this.querySelector('.product-media-modal__content').getBoundingClientRect();
      const x = Number.isFinite(clientX) ? clientX - (rect.left + rect.width / 2) : 0;
      const y = Number.isFinite(clientY) ? clientY - (rect.top + rect.height / 2) : 0;
      const ratio = scale / this.zoomScale;
      this.zoomX = x - (x - this.zoomX) * ratio;
      this.zoomY = y - (y - this.zoomY) * ratio;
      this.zoomScale = scale;
      // Ask the browser for an appropriately sharp source from the image's existing srcset.
      if (!image.dataset.fitSizes) image.dataset.fitSizes = image.sizes;
      image.sizes = scale > 1 ? `${Math.ceil(image.clientWidth * scale)}px` : image.dataset.fitSizes;
      this.paintZoom();
    }
    paintZoom() {
      const image = this.zoomImage;
      if (image) {
        const width = image.clientWidth, height = image.clientHeight;
        const fit = Math.min(width / (image.naturalWidth || width), height / (image.naturalHeight || height));
        const boundX = Math.max(0, ((image.naturalWidth || width) * fit * this.zoomScale - width) / 2);
        const boundY = Math.max(0, ((image.naturalHeight || height) * fit * this.zoomScale - height) / 2);
        this.zoomX = Math.max(-boundX, Math.min(boundX, this.zoomX));
        this.zoomY = Math.max(-boundY, Math.min(boundY, this.zoomY));
        image.style.transform = `translate(${this.zoomX}px, ${this.zoomY}px) scale(${this.zoomScale})`;
        image.style.transformOrigin = 'center';
        if (this.zoomScale === 1 && image.dataset.fitSizes) image.sizes = image.dataset.fitSizes;
      }
      this.classList.toggle('is-detail-zoom', this.zoomScale > 1);
      this.querySelectorAll('.spx-zoom-tools button').forEach(button => { button.disabled = !image; });
      const out = this.querySelector('[data-spx-zoom-out]'); if (out) out.disabled = !image || this.zoomScale <= 1;
      const plus = this.querySelector('[data-spx-zoom-in]'); if (plus) plus.disabled = !image || this.zoomScale >= 4;
      const reset = this.querySelector('[data-spx-zoom-reset]'); if (reset) reset.textContent = `${Math.round(this.zoomScale * 100)}%`;
    }
    startPan(event) {
      if (!this.hasAttribute('open') || event.target !== this.zoomImage || event.button > 0) return;
      if (!this.pointers.size) this.dragged = false;
      this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      event.target.setPointerCapture(event.pointerId);
      if (this.zoomScale > 1) this.classList.add('is-panning');
      if (this.pointers.size === 2) {
        const [a, b] = [...this.pointers.values()];
        this.pinch = { distance: Math.hypot(a.x - b.x, a.y - b.y), scale: this.zoomScale };
        this.dragged = true;
      }
    }
    movePan(event) {
      const previous = this.pointers.get(event.pointerId); if (!previous) return;
      const point = { x: event.clientX, y: event.clientY };
      this.pointers.set(event.pointerId, point);
      if (this.pinch && this.pointers.size === 2) {
        const [a, b] = [...this.pointers.values()];
        this.setZoom(this.pinch.scale * Math.hypot(a.x - b.x, a.y - b.y) / Math.max(1, this.pinch.distance), (a.x + b.x) / 2, (a.y + b.y) / 2);
        return;
      }
      if (this.zoomScale <= 1) return;
      const dx = point.x - previous.x, dy = point.y - previous.y;
      if (Math.abs(dx) + Math.abs(dy) > 2) this.dragged = true;
      this.zoomX += dx; this.zoomY += dy; this.paintZoom();
    }

    get mediaItems() {
      return [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')];
    }

    show(opener) {
      this.finishAnimations();
      this.closing = false;
      const sourceImage = opener.closest('modal-opener')?.querySelector('.product__media img');
      const sourceRect = sourceImage?.getBoundingClientRect();
      super.show(opener);
      const active = this.showActiveMedia();
      if (!this.classList.contains('spx-product-zoom') || this.reducedMotion.matches) return;
      this.animateImage(active, sourceRect);
    }

    showActiveMedia(id = this.openedBy?.getAttribute('data-media-id')) {
      this.mediaItems.forEach(item => { if (item.nodeName === 'IMG') item.style.removeProperty('transform'); });
      const items = this.mediaItems;
      const active = items.find((item) => item.dataset.mediaId === String(id)) || items[0];
      if (!active) return null;
      items.forEach((item) => item.classList.toggle('active', item === active));
      const container = this.querySelector('[role="document"]');
      if (this.classList.contains('spx-product-zoom')) {
        container.scrollTop = container.scrollLeft = 0;
        this.activeIndex = items.indexOf(active);
        const counter = this.querySelector('[data-spx-zoom-count]');
        if (counter) counter.textContent = `${this.activeIndex + 1} / ${items.length}`;
        this.querySelectorAll('[data-spx-zoom-step]').forEach((button) => { button.hidden = items.length < 2; });
      } else {
        active.scrollIntoView();
        container.scrollLeft = ((active.width || container.clientWidth) - container.clientWidth) / 2;
      }
      this.resetZoom();
      if (active.nodeName === 'IMG') active.loading = 'eager';
      const template = active.querySelector('template');
      if (active.nodeName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) active.loadContent();
      return active;
    }

    async step(direction) {
      if (this.closing) return;
      const items = this.mediaItems;
      if (items.length < 2) return;
      const token = this.mediaRequest = (this.mediaRequest || 0) + 1;
      this.finishAnimations();
      window.pauseAllMedia();
      const index = ((this.activeIndex || 0) + direction + items.length) % items.length;
      const next = items[index];
      if (next.nodeName === 'IMG') { next.loading = 'eager'; await next.decode().catch(() => {}); }
      if (token !== this.mediaRequest || this.closing || !this.hasAttribute('open')) return;
      const active = this.showActiveMedia(next.dataset.mediaId);
      if (!this.reducedMotion.matches && active?.animate) {
        this.imageAnimation = active.animate(
          [{ opacity: 0.35, transform: `translateX(${direction * 20}px) scale(.98)` }, { opacity: 1, transform: 'none' }],
          { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' }
        );
      }
    }

    animateImage(image, sourceRect) {
      if (image?.nodeName !== 'IMG' || !image.animate) return;
      const target = image.getBoundingClientRect();
      let start = 'scale(.9)';
      if (sourceRect?.width && target.width && sourceRect.height && target.height) {
        start = `translate(${sourceRect.left + sourceRect.width / 2 - target.left - target.width / 2}px, ${sourceRect.top + sourceRect.height / 2 - target.top - target.height / 2}px) scale(${sourceRect.width / target.width}, ${sourceRect.height / target.height})`;
      }
      this.imageAnimation = image.animate(
        [{ transform: start, opacity: .7 }, { transform: 'none', opacity: 1 }],
        { duration: 440, easing: 'cubic-bezier(.22,1,.36,1)' }
      );
    }

    finishAnimations() {
      this.imageAnimation?.cancel();
      this.closeAnimation?.cancel();
      this.closeAnimation = null;
    }

    hide() {
      if (!this.hasAttribute('open') || this.closing) return;
      this.mediaRequest = (this.mediaRequest || 0) + 1;
      this.resetZoom();
      if (!this.classList.contains('spx-product-zoom') || this.reducedMotion.matches || !this.animate) {
        this.finishAnimations();
        super.hide();
        return;
      }
      this.closing = true;
      this.imageAnimation?.cancel();
      const animation = this.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-out' });
      this.closeAnimation = animation;
      animation.onfinish = () => {
        if (this.closeAnimation !== animation) return;
        super.hide();
        this.closing = false;
        animation.cancel();
        this.closeAnimation = null;
      };
    }
  });
}
